import React, { Component } from 'react';
import '../styles/Instructions.css';

class Instructions extends Component {
  render () {
    return (
      <div className='Instructions'>
        <h1 className='InstructionsTitle'>How it works: </h1>
        <p className='InstructionsText'>
          Pick 5 fantasy books that you really like using the search bar above. Our algorithm analyses your picks, and you get a unique list of awesome fantasy books that matches your taste! Try it! The result is instant, and the service is totally free and has no commercial affiliations. 
        </p>
        <h2 className='InstructionsTitle'>Rules: </h2>
        <p className='InstructionsText'>
          One book per author. If it's a series, pick the first book in the series.
        </p>
        <h2 className='InstructionsTitle'>About: </h2>
        <p className='InstructionsText'>
          Finding new books to read is challenging. Not only any books, but books that fits your personal preferences! That is why recommend me fantasy books was created. The best source for 
          fantasy recommendations, for newcomers and hard-core readers alike. Our recommendation engine analyses what 
          you value as good books, and identifies other like-minded readers creating a unique top fantasy book list tailored for you personal values and preferences.
        </p>
      </div>
    )
  }
}

export default Instructions;


// WEBPACK FOOTER //
// ./src/components/Instructions.js